import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    min-width: 320px;
    background: #f9f9f9;
    width: 100%;
  }
`;

export default GlobalStyle;
